import { Component } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { IonIcon, IonLabel, IonMenu, IonTabBar, IonTabButton, IonTabs } from '@ionic/angular/standalone'
import { TranslatePipe } from '@ngx-translate/core'
import { addIcons } from 'ionicons'
import { cashOutline, documentTextOutline, homeOutline, star, stopwatchOutline } from 'ionicons/icons'

import { DrawerComponent } from '../../shared/components/drawer/drawer.component'

@Component({
	selector: 'app-tabs',
	templateUrl: 'tabs.page.html',
	styleUrls: ['tabs.page.scss'],
	standalone: true,
	imports: [IonTabs, IonTabBar, IonTabButton, IonIcon, IonLabel, IonMenu, FormsModule, DrawerComponent, TranslatePipe],
})
export class TabsPage {
	constructor() {
		addIcons({ star, stopwatchOutline, homeOutline, cashOutline, documentTextOutline })
	}
}
